import * as Actions from '../../actions';

const initialState = { data: null };

const getMilkPrices = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_MILK_PRICES:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default getMilkPrices;
